import { Chip, Avatar } from '@mui/material';
import lock from '../common/lock.png';

const NoPermissionMessage = ({ message = null }) => {
  return (
    <Chip
      avatar={<Avatar alt="Natacha" src={lock} />}
      label={
        message ? message : "You don't have permission to access this action"
      }
      color="error"
      variant="outlined"
    />
  );
};

export default NoPermissionMessage;
